export const APP_VERSION = '1.4.2';

export const APP_YEAR = '2019';

export const USER_TYPE = {
    ADMIN: 1,
    AUDITOR: 2,
    MANAGER: 3
};



// WEBPACK FOOTER //
// ./src/constants/appConstants.js